import React, { Fragment } from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import {
  getVendorInformation,
  checkChgVendorAvailability,
  updateVendorInformation
} from "../../../actions";
import Sanckbar from "../../common/Sanckbar";
import Spinner from "../../common/Spinner";
import StatusModal from "../../common/StatusModal";
import Tooltip from "../../common/Tooltip";

class ManageItemVendorInformationByDc extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false,
    modalButton1ActionParams: []
  };
  constructor() {
    super();
    this.headerData1 = [];
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = [];
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };

  modifyVendor = (id, whse, id2, whseName, isValid, tagName, stateId) => {
    var injectedValues = this.state.header;
    for (let i = 0; i < injectedValues.length; i++) {
      if (injectedValues[i].name === id) {
        injectedValues[i].injectedValue = whse;
        injectedValues[i].label = (
          <div className="with-tooltip">
            <i
              className="material-icons"
              style={isValid ? { color: "green" } : { color: "red" }}
            >
              {isValid ? "check" : "cancel"}
            </i>
            <Tooltip
              msg={isValid ? "Valid Vendor For This Warehouse" : whseName}
            />
            {tagName}
          </div>
        );
      }
      if (injectedValues[i].name === id2) {
        injectedValues[i].injectedValue = whseName;
      }
    }
    this.setState({ header: injectedValues });
    this.newInfo[stateId] = whse;
    this.checkHotChanges();
  };

  lookup = msg => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    if (this.state.lookup && this.state.lookup.item && this.state.lookup.wse) {
      var item = parseInt(this.state.lookup.item, 10).toString();
      getVendorInformation(item, this.state.lookup.wse).then(res => {
        msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");
        if (res.data.success) {
          this.newInfo = [];
          const data = res.data.data;
          // const whsesForItem = res.data.data.whsesForItem;
          // delete data.whsesForItem;
          this.setState({ data });
          this.setState({
            header: [
              {
                label: "Item",
                value: this.numberToZeroPadded(res.data.data.itemNumber, 9),
                name: "item"
              },
              {
                label: "Description",
                value: res.data.data.description,
                name: "description"
              },
              {
                label: "Line",
                value: res.data.data.lineCode,
                name: "line"
              },
              {
                label: "Part",
                value: res.data.data.partNumber,
                name: "part"
              },
              {
                label: "Warehouses",
               // value: whsesForItem,
                name: "wse"
              },
              {
                label: "Vendor",
                value: res.data.data.vend,
                name: "vendor"
              },
              {
                label: "Vendor Name",
                value: res.data.data.hostVendorName,
                name: "vendorName"
              },
              {
                label: "Core Return",
                value: res.data.data.coreReturnVendor,
                name: "coreReturn"
              },
              {
                label: "Vendor Name",
                value: res.data.data.coreReturnVendorName,
                name: "vendorName2"
              },
              {
                label: "Recall",
                value: res.data.data.recallVendor,
                name: "recall"
              },
              {
                label: "Vendor Name",
                value: res.data.data.recallVendorName,
                name: "vendorName3"
              },
              {
                label: "Warranty",
                value: res.data.data.warrantyVendor,
                name: "warranty"
              },
              {
                label: "Vendor Name",
                value: res.data.data.warrantyVendorName,
                name: "vendorName4"
              },
              {
                label: "Next PO Cost",
                value: res.data.data.nipoBaseCost,
                name: "nextPOCost"
              },
              {
                label: "Core",
                value: res.data.data.nipoCoreCost,
                name: "core"
              },
              {
                label: "NIPO Maintenance Date",
                value: res.data.data.nipoMaintDate,
                name: "NPOMaintenanceDate"
              },
              {
                label: "Setup Date",
                value: res.data.data.setupDate,
                name: "setupDate"
              },
              {
                label: "Change Date",
                value: res.data.data.changeDate,
                name: "changeDate"
              }
            ],

            cards: [
              // cards
              {
                Dimensions: [
                  {
                    label: "Cubic Feet",
                    value: res.data.data.cubicFeet,
                    name: "cubicFeet"
                  },
                  {
                    label: "Cases Per Tier",
                    value: res.data.data.unitsPerTier,
                    name: "casesPerTier"
                  },
                  {
                    label: "Units Per Case",
                    value: res.data.data.unitsPerCase,
                    name: "unitsPerCase"
                  },
                  {
                    label: "Tiers Per Pallet",
                    value: res.data.data.tiersPerPallet,
                    name: "tiersPerPallet"
                  }
                ]
              },
              {
                "INFOREM Info": [
                  {
                    label: "Profile ID",
                    value: res.data.data.infPtag,
                    name: "profileID"
                  },
                  {
                    label: "DSER",
                    value: res.data.data.infDser,
                    name: "DSER"
                  },
                  {
                    label: "Profile Year",
                    value: res.data.data.infPtagYear,
                    name: "profileYear"
                  },
                  {
                    label: "Init DESEAS Demand",
                    value: res.data.data.infDDI,
                    name: "initDESEASDemand"
                  }
                ]
              },
              {
                "Vendor Conversion": [
                  {
                    label: "Factor",
                    value: res.data.data.vendConvFactor,
                    name: "factor"
                  },
                  {
                    label: "Action (* OR /)",
                    value: res.data.data.vendConvAction,
                    name: "action"
                  },
                  {
                    label: "Company POQ Multiple",
                    value: res.data.data.companyPoqMult,
                    name: "companyPOQMultiple"
                  }
                ]
              }
            ]
          });
        } else {
          this.setState({
            header: [
              {
                label: "Item",
                // value: this.numberToZeroPadded(res.data.data.itemNumber, 9),
                name: "item"
              },
              {
                label: "Description",
                // value: res.data.data.description,
                name: "description"
              },
              {
                label: "Line",
                // value: res.data.data.lineCode,
                name: "line"
              },
              {
                label: "Part",
                // value: res.data.data.partNumber,
                name: "part"
              },
              {
                label: "Warehouses",
                // value: whsesForItem,
                name: "wse"
              },
              {
                label: "Vendor",
                // value: res.data.data.vend,
                name: "vendor"
              },
              {
                label: "Vendor Name",
                // value: res.data.data.hostVendorName,
                name: "vendorName"
              },
              {
                label: "Core Return",
                // value: res.data.data.coreReturnVendor,
                name: "coreReturn"
              },
              {
                label: "Vendor Name",
                // value: res.data.data.coreReturnVendorName,
                name: "vendorName2"
              },
              {
                label: "Recall",
                // value: res.data.data.recallVendor,
                name: "recall"
              },
              {
                label: "Vendor Name",
                // value: res.data.data.recallVendorName,
                name: "vendorName3"
              },
              {
                label: "Warranty",
                // value: res.data.data.warrantyVendor,
                name: "warranty"
              },
              {
                label: "Vendor Name",
                // value: res.data.data.warrantyVendorName,
                name: "vendorName4"
              },
              {
                label: "Next PO Cost",
                // value: res.data.data.nipoBaseCost,
                name: "nextPOCost"
              },
              {
                label: "Core",
                // value: res.data.data.nipoCoreCost,
                name: "core"
              },
              {
                label: "NIPO Maintenance Date",
                // value: res.data.data.nipoMaintDate,
                name: "NPOMaintenanceDate"
              },
              {
                label: "Setup Date",
                // value: res.data.data.setupDate,
                name: "setupDate"
              },
              {
                label: "Change Date",
                // value: res.data.data.changeDate,
                name: "changeDate"
              }
            ],

            cards: [
              // cards
              {
                Dimensions: [
                  {
                    label: "Cubic Feet",
                    // value: res.data.data.cubicFeet,
                    name: "cubicFeet"
                  },
                  {
                    label: "Cases Per Tier",
                    // value: res.data.data.unitsPerTier,
                    name: "casesPerTier"
                  },
                  {
                    label: "Units Per Case",
                    // value: res.data.data.unitsPerCase,
                    name: "unitsPerCase"
                  },
                  {
                    label: "Tiers Per Pallet",
                    // value: res.data.data.tiersPerPallet,
                    name: "tiersPerPallet"
                  }
                ]
              },
              {
                "INFOREM Info": [
                  {
                    label: "Profile ID",
                    // value: res.data.data.infPtag,
                    name: "profileID"
                  },
                  {
                    label: "DSER",
                    // value: res.data.data.infDser,
                    name: "DSER"
                  },
                  {
                    label: "Profile Year",
                    // value: res.data.data.infPtagYear,
                    name: "profileYear"
                  },
                  {
                    label: "Init DESEAS Demand",
                    // value: res.data.data.infDDI,
                    name: "initDESEASDemand"
                  }
                ]
              },
              {
                "Vendor Conversion": [
                  {
                    label: "Factor",
                    // value: res.data.data.vendConvFactor,
                    name: "factor"
                  },
                  {
                    label: "Action (* OR /)",
                    // value: res.data.data.vendConvAction,
                    name: "action"
                  },
                  {
                    label: "Company POQ Multiple",
                    // value: res.data.data.companyPoqMult,
                    name: "companyPOQMultiple"
                  }
                ]
              }
            ]
          });
          this.setErrorMessage(res.data.messages[0].text);
        }
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setErrorMessage("Please select an item number and a warehouse");
    }
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        item: value.header.item,
        wse: value.header.wse ? value.header.wse[0] : 0,
        whses: value.header.wse
      }
    });
    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      this.newInfo = {
        itemNumber: this.state.data.itemNumber,
        whse:
          this.allData.wse.length > 0 ? this.allData.wse[0].toString() : null,
        setupDate: this.state.data.setupDate,
        changeDate: this.state.data.changeDate,
        vendOverrideId: this.state.data.vendOverrideId,
        nipoMaintDate: this.state.data.nipoMaintDate,
        nipoBaseCost: this.allData.nextPOCost
          ? this.allData.nextPOCost
          : this.state.data.nipoBaseCost,
        nipoCoreCost: this.state.data.nipoCoreCost,
        cubicFeet: this.allData.cubicFeet
          ? this.allData.cubicFeet
          : this.state.data.cubicFeet,
        unitsPerCase: this.allData.unitsPerCase
          ? this.allData.unitsPerCase
          : this.state.data.unitsPerCase,
        unitsPerTier: this.allData.casesPerTier
          ? this.allData.casesPerTier
          : this.state.data.unitsPerTier,
        tiersPerPallet: this.allData.tiersPerPallet
          ? this.allData.tiersPerPallet
          : this.state.data.tiersPerPallet,
        vendConvFactor: this.allData.factor
          ? this.allData.factor
          : this.state.data.vendConvFactor,
        vendConvAction: this.allData.action
          ? this.allData.action
          : this.state.data.vendConvAction,
        companyPoqMult: this.allData.companyPOQMultiple
          ? this.allData.companyPOQMultiple
          : this.state.data.companyPoqMult,
        originalVend: this.state.data.originalVend,
        vend: this.newInfo.vend
          ? this.newInfo.vend
          : this.allData.vendor
          ? this.allData.vendor
          : this.state.data.vend,
        hostVendorName: this.state.header[6].value,
        originalCoreReturnVendor: this.state.data.originalCoreReturnVendor,
        coreReturnVendor: this.newInfo.coreReturnVendor
          ? this.newInfo.coreReturnVendor
          : this.allData.coreReturn
          ? this.allData.coreReturn
          : this.state.data.coreReturnVendor,
        coreReturnVendorName: this.state.data.coreReturnVendorName,
        originalRecallVendor: this.state.data.originalRecallVendor,
        recallVendor: this.newInfo.recallVendor
          ? this.newInfo.recallVendor
          : this.allData.recall
          ? this.allData.recall
          : this.state.data.recallVendor,
        recallVendorName: this.state.data.recallVendorName,
        originalWarVendor: this.state.data.originalWarVendor,
        warrantyVendor: this.newInfo.warrantyVendor
          ? this.newInfo.warrantyVendor
          : this.allData.warranty
          ? this.allData.warranty
          : this.state.data.warrantyVendor,
        warrantyVendorName: this.state.data.warrantyVendorName,
        dcCasesPerTier: this.state.data.dcCasesPerTier,
        lineCode: this.state.data.lineCode,
        partNumber: this.state.data.partNumber,
        description: this.state.data.description,
        infPtag: this.state.data.infPtag,
        infDser: this.state.data.infDser,
        infDDI: this.state.data.infDDI,
        infPtagYear: this.state.data.infPtagYear
      };
      this.checkHotChanges();
    }
  };

  checkHotChanges = () => {
    this.setState({
      isSaveEnabled:
        JSON.stringify(this.state.data).replace(/"/g, "") !==
        JSON.stringify(this.newInfo).replace(/"/g, "")
    });
  };
  save = () => {
    const formattedWhses = this.state.lookup.whses.map(wse => {
      return wse.toString();
    });
    this.setTransitioMessage(<Spinner msg="Saving..." />);

    var uId = sessionStorage.getItem("uId");

    var obj = {
      audit: {
        userId: uId
      },
      whses: formattedWhses,
      data: this.newInfo
    };

    updateVendorInformation(obj).then(res => {
      if (res.data.success) {
        this.setState({ data: "" });
        this.newInfo = "";
        this.lookup("Item was successfully updated");
        this.setSuccessMessage("Item was successfully updated");
        this.setState({ isSaveEnabled: false });
      } else {
        this.setErrorMessage(res.data.messages[0].text);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
  };
  downloadTemplate = () => {
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/template/Item-Vendor Information by DC.xlsx`;
    link.download = 'Item-Vendor Information by DC.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };
  checkVendor = (vendorType, newVendorId) => {
    if (this.state.data) {
      var vdrType;
      var vdrTag;
      var stateName;
      var stateId;
      var originalVendorId;
      var tagName;
      switch (vendorType) {
        case "vendor":
          vdrType = "HV";
          vdrTag = "vendorName";
          stateName = "hostVendorName";
          stateId = "vend";
          tagName = "Vendor";
          break;
        case "coreReturn":
          vdrType = "CV";
          vdrTag = "vendorName2";
          stateName = "coreReturnVendorName";
          stateId = "coreReturnVendor";
          tagName = "Core Return";
          break;
        case "warranty":
          vdrType = "WV";
          vdrTag = "vendorName4";
          stateName = "warrantyVendorName";
          stateId = "warrantyVendor";
          tagName = "Warranty";
          break;
        case "recall":
          vdrType = "RV";
          vdrTag = "vendorName3";
          stateName = "recallVendorName";
          stateId = "recallVendor";
          tagName = "Recall";
          break;
        default:
          break;
      }

      /*
    originalVendorId,
    newVendorId,
    whse,
    vendorType
    */
      newVendorId = newVendorId.replace(/\s/gi, "");
      var _newVendorId =
        newVendorId.length > 0 ? newVendorId : this.state.data[stateId];

      checkChgVendorAvailability(
        this.state.data[stateId],
        _newVendorId,
        this.state.data.whse,
        vendorType
      ).then(res => {
        if (res.data.success === false) {
          this.modifyVendor(
            vendorType,
            _newVendorId,
            vdrTag,
            "Invalid Vendor For This Warehouse",
            false,
            tagName,
            stateId
          );
          this.setErrorMessage("Invalid Vendor For This Warehouse");
        } else {
          const newVendorName =
            res.data.success !== null
              ? res.data.vendorName
              : this.state.data[stateName];
          this.modifyVendor(
            vendorType,
            _newVendorId,
            vdrTag,
            newVendorName,
            true,
            tagName,
            stateId
          );
          this.setState({
            modalButton1ActionParams: [_newVendorId, newVendorName]
          });
          if (this.state.data[stateId] !== _newVendorId) {
            this.handeOpenModal(
              "choice",
              `${newVendorName} (${_newVendorId}), is valid for this warehouse, Apply for all vendors?`,
              "YES",
              "NO",
              false
            );
          }
        }
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
      this.checkHotChanges();
    }
  };
  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };

  handeOpenModal = (param, param2, param3, param4, param5) => {
    this.setState({ modalOpen: true });

    // if (this.state.data) {
    this.setState({ action: param });
    this.setState({ modalMsg: param2 });
    this.setState({ modalButtonText: param3 });
    this.setState({ modalButtonText2: param4 });
    if (param === "success" || param === "fail") {
      this.setState({ onlyClose: true });
    } else {
      this.setState({ onlyClose: false });
    }
    this.setState({ modalReturn: param5 });
    // }
  };
  closeModal = e => {
    this.setState({ modalOpen: false });
  };
  modifyAllVendors = (x, y) => {
    this.modifyVendor("vendor", x, "vendorName", y, true, "Vendor", "vend");
    this.modifyVendor(
      "coreReturn",
      x,
      "vendorName2",
      y,
      true,
      "Core Return",
      "coreReturnVendor"
    );
    this.modifyVendor(
      "recall",
      x,
      "vendorName3",
      y,
      true,
      "Recall",
      "recallVendor"
    );
    this.modifyVendor(
      "warranty",
      x,
      "vendorName4",
      y,
      true,
      "Warranty",
      "warrantyVendor"
    );
    this.closeModal();
    // this.mockValues2(
    //   ["vendor", "coreReturn", "recall", "warranty"],
    //   5,
    //   ["vendorName", "vendorName2", "vendorName3", "vendorName4"],
    //   "Name"
    // );

    return null;
  };
  componentDidUpdate() {}
  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }

  handleOpenModal = () => {
    this.state.modal2Open
      ? this.setState({ modal2Open: false })
      : this.setState({ modal2Open: true });
  };
  closeModal2 = e => {
    this.setState({ modal2Open: false });
  };
  closeEP = x => {
    if (x) {
      x.target.textContent === "Save"
        ? this.save()
        : this.setSuccessMessage("Changes discarded");

      setTimeout(() => {
        this.closeEP();
      }, 1500);
    } else {
      this.props.history.push("/");
    }
  };

  checkHotChangesAndClose = () => {
    if (this.state.isSaveEnabled) {
      this.handleOpenModal();
    } else {
      this.closeEP();
    }
  };

  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          Item-Vendor Information By DC
        </h3>
        {/* <div onClick={e => this.mockValues2()}>inject</div> */}
        <HeaderLayout
          headerData={this.state.header}
          setHeaderInfo={this.getHeaderInfo}
          lookup={this.lookup}
          checkVendor={this.checkVendor}
          setErrorMessage={this.setErrorMessage}
          setSuccessMessage={this.setSuccessMessage}
        />
        <CardsLayout
          cardsData={this.state.cards}
          setCardsInfo={this.getCardsInfo}
        />
        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons">
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={false}
              onClick={e => this.checkHotChangesAndClose()}
            >
              Close
            </Button>
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={false}
              onClick={this.downloadTemplate}
            >
              Download Template
            </Button>
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isSaveEnabled}
              onClick={e => this.save()}
            >
              Save
            </Button>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
        <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={this.state.action}
          handleOpenClose={e => this.closeModal(e)}
          buttonActions={{
            button1: e =>
              this.modifyAllVendors(
                this.state.modalButton1ActionParams[0],
                this.state.modalButton1ActionParams[1]
              ),
            button2: e => this.closeModal(e)
          }}
          hasOnlyClose={this.state.onlyClose}
          title={this.state.modalTitle}
          msg={this.state.modalMsg}
          icon={this.state.modalIcon}
          active={true}
          buttonText={this.state.modalButtonText}
          buttonText2={this.state.modalButtonText2}
          noReturn={!this.state.modalReturn}
        />
        <StatusModal
          modal={this.state.modal2Open === true ? "opened" : "closed"}
          action={"choice"}
          handleOpenClose={e => this.closeModal2(e)}
          buttonActions={{
            button2: this.closeEP,
            button1: this.closeEP
          }}
          msg={
            "There are unsaved changes. Please select one of the following actions."
          }
          active={true}
          buttonText2={"Save"}
          buttonText={"Discard"}
        />
      </div>
    );
  }
}
export default ManageItemVendorInformationByDc;
